import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import { CartProvider } from "./context/CartContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SplashIntro } from "./components/SplashIntro";
import { useSiteConfig } from "./hooks/useSiteConfig";

import Home from "./pages/Home";
import Art from "./pages/Art";
import Prints from "./pages/Prints";
import PrintDetail from "./pages/PrintDetail";
import Cart from "./pages/Cart";
import Murals from "./pages/Murals";
import Events from "./pages/Events";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.12, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
};

const Shell = () => {
  useLenis();
  const config = useSiteConfig();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <div className="grain min-h-screen bg-ink text-bone">
      <ScrollToTop />
      {location.pathname === "/" && <SplashIntro />}
      {!isAdmin && <Header instagram={config?.instagram} />}
      <main>
        <Routes>
          <Route path="/" element={<Home config={config} />} />
          <Route path="/art" element={<Art />} />
          <Route path="/prints" element={<Prints />} />
          <Route path="/prints/:id" element={<PrintDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/murals" element={<Murals />} />
          <Route path="/events" element={<Events />} />
          <Route path="/about" element={<About config={config} />} />
          <Route path="/contact" element={<Contact config={config} />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!isAdmin && <Footer instagram={config?.instagram} />}
      <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#1A1A1A", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 0 } }} />
    </div>
  );
};

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
